export class ClientSideStateManager {
    setSerializedStates(serializedStates) {
        this.serializedStatesByConsumerId = JSON.parse(decodeURI(serializedStates));
    }
    getSerializedState(consumerId) {
        return (this.serializedStatesByConsumerId &&
            this.serializedStatesByConsumerId[consumerId]);
    }
}
//# sourceMappingURL=client-side-state-manager.js.map